/* ============================================================
   whatsapp-origem.js (Colmeia, 28/10/2026)
   Padroniza os links de WhatsApp do 2005 para o atendimento saber de onde
   o cliente veio. Não muda o visual: só o texto pré-preenchido.

   1. Primeiro toque: na chegada ao site guarda por 30 dias a origem do
      visitante (utm_source, fbclid, gclid, ttclid). Assim quem clica no
      WhatsApp dias depois ainda conta como vindo do anúncio.
   2. Link sem texto ou com a frase antiga genérica vira a frase padrão:
      "Olá! Vim pelo site da Robusta e quero tirar uma dúvida."
      Na página de produto, o produto entra na frase.
      Nas páginas de troca e garantia, a frase é de suporte ao pedido.
   3. Quando houver origem de anúncio, acrescenta "(ref: meta)",
      "(ref: google)" ou "(ref: tiktok)". O atendimento (Colmeia) etiqueta
      a conversa por essas palavras.
   Para reverter: remover o <script> deste arquivo em sections/announcement-bar.liquid.
   ============================================================ */
(function () {
  'use strict';
  var NUMERO = '551531422005';
  var CHAVE = 'robusta_origem_v1';
  var DIAS = 30;
  var GENERICAS = [/^\s*$/, /gostaria de saber mais sobre os produtos da robusta/i];

  function ler() {
    try { var o = JSON.parse(localStorage.getItem(CHAVE) || 'null'); if (o && o.exp > Date.now()) return o; } catch (e) {}
    return null;
  }
  function gravar(ref) {
    try { localStorage.setItem(CHAVE, JSON.stringify({ ref: ref, exp: Date.now() + DIAS * 864e5 })); } catch (e) {}
  }
  function refDaUrl() {
    var p; try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    var src = (p.get('utm_source') || '').toLowerCase();
    if (p.get('fbclid') || /facebook|instagram|meta|^fb$|^ig$/.test(src)) return 'meta';
    if (p.get('gclid') || p.get('gbraid') || p.get('wbraid') || /google|youtube/.test(src)) return 'google';
    if (p.get('ttclid') || /tiktok/.test(src)) return 'tiktok';
    return null;
  }

  var achada = refDaUrl();
  if (achada) gravar(achada);
  var origem = ler();
  var ref = origem ? origem.ref : null;

  function fraseBase() {
    var path = location.pathname;
    if (/\/pages\/(troca|garantia)/.test(path)) return 'Olá! Vim pelo site da Robusta e preciso de ajuda com meu pedido.';
    if (/\/products\//.test(path)) {
      var h1 = document.querySelector('h1');
      var nome = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
      if (nome && nome.length < 80) return 'Olá! Vim pelo site da Robusta, vi o produto ' + nome + ' e quero tirar uma dúvida.';
    }
    return 'Olá! Vim pelo site da Robusta e quero tirar uma dúvida.';
  }

  function ajustar(a) {
    if (a.__robustaOrigem) return;
    var url; try { url = new URL(a.href); } catch (e) { return; }
    var ehWa = /(^|\.)wa\.me$/.test(url.hostname) || /whatsapp\.com$/.test(url.hostname);
    if (!ehWa || (url.pathname.replace(/\D/g, '') + (url.searchParams.get('phone') || '')).indexOf(NUMERO) === -1) return;
    var texto = url.searchParams.get('text') || '';
    if (GENERICAS.some(function (re) { return re.test(texto); })) texto = fraseBase();
    if (ref && texto.indexOf('(ref:') === -1) texto += ' (ref: ' + ref + ')';
    url.searchParams.set('text', texto);
    a.href = url.toString();
    a.__robustaOrigem = true;
  }
  function varrer() { document.querySelectorAll('a[href*="wa.me"], a[href*="whatsapp.com"]').forEach(ajustar); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varrer); else varrer();
  // links criados depois (PageFly, popups): ajusta no clique também
  document.addEventListener('click', function (e) { var a = e.target.closest && e.target.closest('a'); if (a) ajustar(a); }, true);
})();
